export function ThinkingIndicator() {
  return (
    <div class="thinking" role="status" aria-live="polite">
      <span class="thinking__dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
      <span>The judge is thinking…</span>
    </div>
  );
}
